import React from 'react';
import { Box, CircularProgress, Fade } from '@mui/material';

const LoadingPage = () => {
  return (
    <Fade in={true} timeout={500}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#f8fafc',
          gap: 3
        }}
      >
        {/* Logo */}
        <Box
          component="img"
          src="/e34a06cc-2cae-4f30-b8c3-c9ac9ef01f48.png"
          alt="Logo"
          sx={{
            maxWidth: 200,
            maxHeight: 200,
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            filter: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.1))',
            animation: 'pulse 2s ease-in-out infinite'
          }}
        />
        
        {/* Loading指示器 */}
        <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress
            size={40}
            thickness={3}
            sx={{
              color: '#6366f1',
              '& .MuiCircularProgress-circle': {
                strokeLinecap: 'round',
              }
            }}
          />
        </Box>
        
        {/* 可选：添加loading文本 */}
        <Box
          sx={{
            color: '#64748b',
            fontSize: '14px',
            fontWeight: 500,
            letterSpacing: '0.025em',
            opacity: 0.8
          }}
        >
          Loading...
        </Box>
        
        {/* CSS动画 */}
        <style jsx>{`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
              transform: scale(1);
            }
            50% {
              opacity: 0.8;
              transform: scale(0.98);
            }
          }
        `}</style>
      </Box>
    </Fade>
  );
};

export default LoadingPage;